import onClickOutside from 'react-onclickoutside'
import React, { Component } from 'react'
import PropTypes from 'prop-types'


class InputForm extends Component {
  constructor(props){
    super(props)
    this.state = {
      open: false,
      value: props.value,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && !this.state.open) {
      this.setState({ value: this.props.value })
    }
  }

  normalizedValue = () => {
    const { validate } = this.props
    if (!validate) return this.state.value
    const result = validate(this.state.value)
    if (result === '' && this.state.value !== '') {
      return this.props.value || ''
    }
    return result
  }

  handleClickOutside = (event) => {
    if (this.state.open) {
      const completed = this.normalizedValue()
      this.setState({ open: false, value: completed }, () => event.target.click())
      this.props.onEditCompleted(completed)
    }
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      const completed = this.normalizedValue()
      this.setState({ open: false, value: completed })
      this.props.onEditCompleted(completed)
      event.target.blur()
    }
  }

  render() {
    return (
        <input id={this.props.id} className={this.props.className} type={this.props.type} value={this.state.value} onMouseDown={() => this.setState({ open: true})} onChange={e => this.setState({ value: e.target.value})} onKeyDown={this.handleKeyPress} />
    )
  }
}

InputForm.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  onEditCompleted: PropTypes.func,
  validate: PropTypes.func,
}

InputForm.defaultProps = {
  value: '',
  className: '',
  type: 'text',
  id: null,
  onEditCompleted: () => {},
  validate: null,
}
export default onClickOutside(InputForm)
